import { useLocation } from 'react-router-dom'

import * as api from '@owl-nest/api-client/latest'
import * as model from '@owl-nest/models'

import * as projectModel from '../models/project'

export type DisplayMode = 'preview' | 'edit' | 'view'

export function useDisplayMode(project: projectModel.Project): DisplayMode {
  const location = useLocation()
  const userPermissions = project.permissions.self

  const preview = isPreview(location.pathname)
  const isProjectCancelled = model.project.isCancelled<projectModel.ExtraFields>(project)

  if (isProjectCancelled) {
    // no preview when project is archived/cancelled
    return userPermissions?.includes(api.ProjectSelfPermission.UPDATE) ? 'edit' : 'view'
  } else {
    return userPermissions?.includes(api.ProjectSelfPermission.UPDATE) ? (preview ? 'preview' : 'edit') : 'view'
  }
}

export function isPreview(pathname: string): boolean {
  return pathname.includes('/preview/')
}
